import { render, staticRenderFns } from "./selesai.vue?vue&type=template&id=3786c4c1&"
import script from "./selesai.vue?vue&type=script&lang=js&"
export * from "./selesai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports